import { createStructuredSelector } from 'reselect'

import {
  EQUIPMENT_STOCK_DETAIL_LIST,
  EQUIPMENT_STOCK_DETAIL_LIST_SUCCESS, 
  EQUIPMENT_STOCK_DETAIL_LIST_ERROR,
  EQUIPMENT_STOCK_DETAIL_PAGE_SET,
  EQUIPMENT_STOCK_DETAIL_SEARCH_SET,
  EQUIPMENT_STOCK_DETAIL_SEARCH_CHANGE,
  EQUIPMENT_STOCK_DETAIL_SEARCH_EQUIPMENT_STOCK,
  EQUIPMENT_STOCK_DETAIL_SEARCH_EQUIPMENT_STOCK_SUCCESS,
  EQUIPMENT_STOCK_DETAIL_SEARCH_EQUIPMENT_STOCK_ERROR,
  EQUIPMENT_STOCK_DETAIL_SEARCH_APPLY_OPTION,
  EQUIPMENT_STOCK_DETAIL_SEARCH_APPLY_OPTION_SUCCESS,
  EQUIPMENT_STOCK_DETAIL_SEARCH_APPLY_OPTION_ERROR,
  EQUIPMENT_STOCK_DETAIL_ADD_SET,
  EQUIPMENT_STOCK_DETAIL_ADD_MODAL_SET,
  EQUIPMENT_STOCK_DETAIL_ADD,
  EQUIPMENT_STOCK_DETAIL_ADD_SUCCESS,
  EQUIPMENT_STOCK_DETAIL_ADD_ERROR,
  EQUIPMENT_STOCK_DETAIL_ADD_CHANGE,
  EQUIPMENT_STOCK_DETAIL_DETAIL,
  EQUIPMENT_STOCK_DETAIL_DETAIL_SUCCESS,
  EQUIPMENT_STOCK_DETAIL_DETAIL_ERROR,
  EQUIPMENT_STOCK_DETAIL_VIEW_MODAL_SET,
  EQUIPMENT_STOCK_DETAIL_EDIT_CHANGE,
  EQUIPMENT_STOCK_DETAIL_EDIT_MODAL_SET,
  EQUIPMENT_STOCK_DETAIL_UPDATE,
  EQUIPMENT_STOCK_DETAIL_UPDATE_SUCCESS,
  EQUIPMENT_STOCK_DETAIL_UPDATE_ERROR,
  EQUIPMENT_STOCK_DETAIL_VIEW_TAB_SET
} from '../../actions';

export const NAME = 'equipment_stock_detail';

export const EquipmentStockDetailList = (page, num_page, orderBy, filters, stateFilter, display) => ({
  type: EQUIPMENT_STOCK_DETAIL_LIST,
  payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, filtersState: stateFilter, display: display }
});

export const EquipmentStockDetailListSuccess = (data) => ({
  type: EQUIPMENT_STOCK_DETAIL_LIST_SUCCESS,
  payload: data
});

export const EquipmentStockDetailListError = (error) => ({
  type: EQUIPMENT_STOCK_DETAIL_LIST_ERROR,
  payload: error
});

export const EquipmentStockDetailPageSet = (data) => ({
  type: EQUIPMENT_STOCK_DETAIL_PAGE_SET,
  payload: data
});

export const EquipmentStockDetailSearchSet = (data) => ({
  type: EQUIPMENT_STOCK_DETAIL_SEARCH_SET,
  payload: data
});

export const EquipmentStockDetailSearchChangeSet = (data) => ({
  type: EQUIPMENT_STOCK_DETAIL_SEARCH_CHANGE,
  payload: data
});

export const EquipmentStockDetailSearchEquipmentStock = (data) => ({
  type: EQUIPMENT_STOCK_DETAIL_SEARCH_EQUIPMENT_STOCK,
  payload: data
});

export const EquipmentStockDetailSearchEquipmentStockSuccess = (message) => ({
  type: EQUIPMENT_STOCK_DETAIL_SEARCH_EQUIPMENT_STOCK_SUCCESS,
  payload: message
});

export const EquipmentStockDetailSearchEquipmentStockError = (error) => ({
  type: EQUIPMENT_STOCK_DETAIL_SEARCH_EQUIPMENT_STOCK_ERROR,
  payload: error
}); 

export const EquipmentStockDetailSearchApplyOption = (data) => ({
  type: EQUIPMENT_STOCK_DETAIL_SEARCH_APPLY_OPTION,
  payload: data
});

export const EquipmentStockDetailSearchApplyOptionSuccess = (message) => ({
  type: EQUIPMENT_STOCK_DETAIL_SEARCH_APPLY_OPTION_SUCCESS,
  payload: message
});

export const EquipmentStockDetailSearchApplyOptionError = (error) => ({
  type: EQUIPMENT_STOCK_DETAIL_SEARCH_APPLY_OPTION_ERROR,
  payload: error
}); 

export const EquipmentStockDetailAddChangeSet = (data) => ({
  type: EQUIPMENT_STOCK_DETAIL_ADD_CHANGE,
  payload: data
});

export const EquipmentStockDetailAddSet = (data) => ({
  type: EQUIPMENT_STOCK_DETAIL_ADD_SET,
  payload: data
});

export const EquipmentStockDetailAddModalSet = (data) => ({
  type: EQUIPMENT_STOCK_DETAIL_ADD_MODAL_SET,
  payload: data
});

export const EquipmentStockDetailAdd = (data) => ({
  type: EQUIPMENT_STOCK_DETAIL_ADD,
  payload: data
});

export const EquipmentStockDetailAddSuccess = (message) => ({
  type: EQUIPMENT_STOCK_DETAIL_ADD_SUCCESS,
  payload: message
});

export const EquipmentStockDetailAddError = (error) => ({
  type: EQUIPMENT_STOCK_DETAIL_ADD_ERROR,
  payload: error
});

export const EquipmentStockDetailDetail = (data) => ({
  type: EQUIPMENT_STOCK_DETAIL_DETAIL,
  payload: data
});

export const EquipmentStockDetailDetailSuccess = (data) => ({
  type: EQUIPMENT_STOCK_DETAIL_DETAIL_SUCCESS,
  payload: data
});

export const EquipmentStockDetailDetailError = (error) => ({
  type: EQUIPMENT_STOCK_DETAIL_DETAIL_ERROR,
  payload: error
});

export const EquipmentStockDetailViewModalSet = (data) => ({
  type: EQUIPMENT_STOCK_DETAIL_VIEW_MODAL_SET,
  payload: data
});

export const EquipmentStockDetailEditModalSet = (data) => ({
  type: EQUIPMENT_STOCK_DETAIL_EDIT_MODAL_SET,
  payload: data
});

export const EquipmentStockDetailEditChangeSet = (data) => ({
  type: EQUIPMENT_STOCK_DETAIL_EDIT_CHANGE,
  payload: data
});

export const EquipmentStockDetailUpdate = (data) => ({
  type: EQUIPMENT_STOCK_DETAIL_UPDATE,
  payload: data
});

export const EquipmentStockDetailUpdateSuccess = (message) => ({
  type: EQUIPMENT_STOCK_DETAIL_UPDATE_SUCCESS,
  payload: message.message
});

export const EquipmentStockDetailUpdateError = (error) => ({
  type: EQUIPMENT_STOCK_DETAIL_UPDATE_ERROR,
  payload: error
});

export const EquipmentStockDetailViewTabSet = (data) => ({
  type: EQUIPMENT_STOCK_DETAIL_VIEW_TAB_SET,
  payload: data
});

const equipment_stock_detail = (state) => state[NAME];

export const EquipmentStockDetailSelector = createStructuredSelector({
  equipment_stock_detail
})
 